import { each, max, map } from "lodash";

declare const jQuery: any;
const $ = jQuery;

const config = Object.freeze({
	dfWait: 4000,
	minWait: 1000,
	minItemsPerGroup: 1,
	dfItemsPerGroup: [
		{ minWindowWidth: 500, nItems: 2 },
		{ minWindowWidth: 768, nItems: 3 },
		{ minWindowWidth: 1200, nItems: 4 }
	]
});

export interface ItemsPerGroupSetting
{
	minWindowWidth: number;
	nItems: number;
}

export function getItemsPerGroupDataFromWrapAttr($wrap, dfItemsPerGroup = config.dfItemsPerGroup): ItemsPerGroupSetting[]
{
	const attrVal: string = $wrap.attr("data-slider-items-per-group")
	if (!attrVal)
	{
		return dfItemsPerGroup;
	}
	return map(attrVal.split(/\s*\,\s*/g), (widthNumItemsString: string) => {
		const widthNumItemsSubstrings: string[] = widthNumItemsString.split(/\s*\:\s*/g);
		return {
			minWindowWidth: parseInt(widthNumItemsSubstrings[0], 10),
			nItems: parseInt(widthNumItemsSubstrings[1], 10)
		};
	});
}

export function findHighestItemsPerGroupValue(settings: ItemsPerGroupSetting[]): number|undefined
{
	let highest = undefined;
	each(settings, (setting: ItemsPerGroupSetting) => {
		if (highest === undefined || highest < setting.nItems)
		{
			highest = setting.nItems;
		}
	});
	return highest;
}

export function getWaitValueFromWrapAttr($wrap, allowNoWait: boolean = true, dfWait: number = config.dfWait, minWait: number = config.minWait): number|undefined
{
	const strValue: string = $wrap.attr("data-auto-slide-wait");
	if (!strValue)
	{
		return allowNoWait ? undefined : dfWait;
	}
	const numValue: number = parseFloat(strValue);
	if (numValue <= 0)
	{
		return allowNoWait ? undefined : dfWait;
	}
	return numValue ? max([minWait, numValue * 1000]) : (allowNoWait ? undefined : dfWait);
}

export function getAutoSlideCountValueFromWrapAttr($wrap): number|"group"|undefined {
	const val: string = $wrap.attr("data-auto-slide-count") as string;
	if (!val) {
		return undefined;
	}
	if (val === "group") {
		return val;
	}
	return parseInt(val, 10) || undefined;
}

export function getItemsPerGroup($window, itemsPerGroupSettings): number
{
	let itemsPerGroup: number = config.minItemsPerGroup;
	const w: number = $window.outerWidth();
	each(itemsPerGroupSettings, cfg => {
		if (w < cfg.minWindowWidth)
		{
			return false;
		}
		itemsPerGroup = cfg.nItems;
	});
	return itemsPerGroup;
}

export function itemsPerGroupObjectToHtmlAttr(itemsPerGroup: ItemsPerGroupSetting[]): string
{
	return map(itemsPerGroup, (setting: ItemsPerGroupSetting) => {
		return setting.minWindowWidth + ":" + setting.nItems;
	}).join(",");
}

export function highlightGroupControl($wrap, groupIndex: number): void
{
	const wrapSelector = ".dot-controls,.number-controls";
	const $ctrlWrap = $wrap.find(wrapSelector).add($wrap.filter(wrapSelector));
	const $controls = $ctrlWrap.find(".dot,.number");
	$controls.removeClass("selected").filter(function () {
		return $(this).index() === groupIndex;
	}).addClass("selected");
}
